if ($('html[lang="en"]').length) {
    var hodnoceni = 'Rating';
    var nakupnikosik = 'Shopping Cart';
    var tooltipMin = 'You cannot purchase more than 9999 pcs.';
    var toolltipMax = 'The minimum quantity to purchase is 1 pc.';
    var sDPH = 'incl. VAT';
    var bezDPH = 'excl. VAT';
    var od = 'from';
    var DMOC = 'RRP is';
    var Parametry = 'Specifications';
    var zvolte = 'Choose variant';
    var dleVarianty = 'Depends on variant';
    var Recepty = 'Recipes';
    var clankyKProduktu = 'Related articles';
    var overeneHodnoceni = 'Verified rating';
    var uzivatelskeJmeno = 'Username or email';
    var heslo = 'Password';
    var poradit = 'Need help';
    var titlePoradit = 'Do you have a question about this product?';
    var dotazy = 'We’ll gladly answer all your questions';
}

if ($('html[lang="de"]').length) {
    var hodnoceni = 'Bewertung';
    var nakupnikosik = 'Warenkorb';
    var tooltipMin = 'Sie können nicht mehr als 9999 Stück kaufen.';
    var toolltipMax = 'Die Mindestmenge beträgt 1 Stück.';
    var sDPH = 'inkl. MwSt.';
    var bezDPH = 'zzgl. MwSt.';
    var od = 'ab';
    var DMOC = 'UVP ist';
    var Parametry = 'Spezifikationen';
    var zvolte = 'Variante wählen';
    var dleVarianty = 'Je nach Variante';
    var Recepty = 'Rezepte';
    var clankyKProduktu = 'Zugehörige Artikel';
    var overeneHodnoceni = 'Verifizierte Bewertung';
    var uzivatelskeJmeno = 'Benutzername oder E-Mail';
    var heslo = 'Passwort';
    var poradit = 'Brauchen Sie Hilfe';
    var titlePoradit = 'Haben Sie eine Frage zum Produkt?';
    var dotazy = 'Wir beantworten gerne alle Ihre Fragen';
}

if ($('html[lang="sk"]').length) {
    var hodnoceni = 'Hodnotenie';
    var nakupnikosik = 'Nákupný košík';
    var tooltipMin = 'Nie je možné zakúpiť viac ako 9999 ks.';
    var toolltipMax = 'Minimálne množstvo na nákup je 1 ks.';
    var sDPH = 's DPH';
    var bezDPH = 'bez DPH';
    var od = 'od';
    var DMOC = 'DMOC je';
    var Parametry = 'Parametre';
    var zvolte = 'Zvoľte variant';
    var dleVarianty = 'Podľa variantu';
    var Recepty = 'Recepty';
    var clankyKProduktu = 'Výber článkov k produktu';
    var overeneHodnoceni = 'Overené hodnotenie';
    var uzivatelskeJmeno = 'Používateľské meno alebo e-mail';
    var heslo = 'Heslo';
    var poradit = 'Potrebujete poradiť';
    var titlePoradit = 'Chcete sa na niečo opýtať k produktu?';
    var dotazy = 'Radi odpovieme na všetky vaše otázky';
}

if ($('html[lang="cs"]').length) {
    var hodnoceni = 'Hodnocení';
    var nakupnikosik = 'Nákupní košík';
    var tooltipMin = 'Není možné zakoupit více než 9999 ks.';
    var toolltipMax = 'Minimální množství, které lze zakoupit, je 1 ks.';
    var sDPH = 's DPH';
    var bezDPH = 'bez DPH';
    var od = 'od';
    var DMOC = 'DMOC je';
    var Parametry = 'Parametry';
    var zvolte = 'Zvolte variantu';
    var dleVarianty = 'Dle varianty';
    var Recepty = 'Recepty';
    var clankyKProduktu = 'Výběr článků k produktu';
    var overeneHodnoceni = 'Ověřené hodnocení';
    var uzivatelskeJmeno = 'Uživatelské jméno nebo e-mail';
    var heslo = 'Heslo';
    var poradit = 'Potřebujete poradit';
    var titlePoradit = 'Chcete se k produktu na něco zeptat?';
    var dotazy = 'Rádi Vám odpovíme na všechny dotazy';
}
